import { InputNumber, Slider } from "antd";
import { useState } from "react";
import Typography from "../Typography/Typography";

export default function RangeSlider({
  onChange,
  min,
  max,
  value = [min, max],
}: {
  min: number;
  max: number;
  value?: number[];
  onChange?: (value: number[]) => void;
}) {
  const [range, setRange] = useState<number[]>(value);

  const onRangeChange = (newValue: number[]) => {
    setRange(newValue);
    onChange?.(newValue);
  };

  return (
    <div>
      <div className="w-full min-w-fit flex flex-col gap-2 items-start justify-start">
        <Typography
          type="span"
          fontFamily="font-kanit"
          fontWeight="font-light"
          customStyles="text-nowrap"
        >
          Min value:
        </Typography>
        <InputNumber
          min={min}
          max={max}
          value={range[0]}
          onChange={(val) => onRangeChange([Number(val), range[1]])}
        />
      </div>
      <div className="w-full flex-col min-w-fit flex gap-2 items-start justify-start">
        <Typography
          type="span"
          fontFamily="font-kanit"
          fontWeight="font-light"
          customStyles="text-nowrap"
        >
          Max value:
        </Typography>
        <InputNumber
          min={min}
          max={max}
          value={range[1]}
          onChange={(val) => onRangeChange([range[0], Number(val)])}
        />
      </div>
      <div>
        <Slider
          range
          min={min}
          max={max}
          value={range}
          onChange={onRangeChange}
        />
      </div>
    </div>
  );
}
